import { profileConfig } from "@/api/instances";
import { useMsal } from "@azure/msal-react";
import { useEffect } from "react";
import useConfig from "./useConfig";

export default function useAxiosMiddleware() {
  const { instance } = useMsal();
  const config = useConfig();

  useEffect(() => {
    const authMiddlewareID = profileConfig.interceptors.request.use(
      async (req) => {
        try {
          // Attempt to acquire token silently
          const accounts = instance.getAllAccounts();
          if (accounts.length === 0) {
            console.warn("Auth: No MSAL account found yet, skipping token set.");
            return req;
          }
          const tokenRes = await instance.acquireTokenSilent({
            account: accounts[0],
            scopes: [config.msalApplicationId],
          });
          req.headers.Authorization = `Bearer ${tokenRes.accessToken}`;
        } catch (error) {
          if (
            error instanceof Error &&
            error.name === "InteractionRequiredAuthError"
          ) {
            // Fallback to interactive method via redirect if silent token acquisition fails
            try {
              // Note: acquireTokenRedirect does not return a response as it redirects the user.
              await instance.acquireTokenRedirect({
                scopes: [config.msalApplicationId],
              });
            } catch (redirectError) {
              console.error(
                "Error with token acquisition redirect:",
                redirectError
              );
              // Handle errors or redirect to login
            }
          } else {
            console.error("Non-interactive error:", error);
            // Handle other errors (like network issues)
          }
        }

        return req;
      }
    );

    return () => {
      profileConfig.interceptors.request.eject(authMiddlewareID);
    };
  }, [config.msalApplicationId, instance]);
}
